import { render, staticRenderFns } from "./SheduleTablePage.vue?vue&type=template&id=212708a2"
import script from "./SheduleTablePage.vue?vue&type=script&lang=js"
export * from "./SheduleTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports